import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "../locales/it.json";
import de from "../locales/de.json";
import fr from "../locales/fr.json";

export const SUPPORTED_LANGS = [
  { code: "it", label: "Italiano", short: "IT" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "fr", label: "Français", short: "FR" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      de: { translation: de },
      fr: { translation: fr },
    },
    fallbackLng: "it",
    supportedLngs: ["it", "de", "fr"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "fitagenda_lang",
    },
  });

export default i18n;
